<template>
  <div class="device-overview-card">
    <!-- 表格主体 -->
    <div class="list">
      <div class="iterm" v-for="(item, index) in data" :key="index">
        <el-card class="product-card">
          <!-- 产品图片区域 -->
          <div class="product-img">
            <el-image v-if="item.img_id" class="img-content" :src="`${imgUrl}${item.img_id}`"
              :preview-src-list="[`${imgUrl}${item.img_id}`]" fit="contain">
            </el-image>
            <!-- 无图片时的占位图 -->
            <div v-else class="no-img-placeholder">无图片</div>
            <el-tag v-if="item.hot === 2" type="danger" size="small" class="hot-tag">热销</el-tag>
          </div>
          <!-- 产品信息区域 -->
          <div class="product-info">
            <h3 class="product-name">{{ item.name }}</h3>
            <p class="product-type">{{ item.product_type }}</p>
            <p class="product-desc">{{ item.description }}</p>
            <div class="product-footer">
              <span class="product-date">{{ formatDateTime(item.created_at) }}</span>
              <div class="product-actions">
                <el-button type="text" icon="el-icon-edit" size="medium" @click="editProduct(item)"></el-button>
                <el-button type="text" icon="el-icon-delete" size="medium" class="delete-btn"
                  @click="deleteProduct(item)"></el-button>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <!-- 分页控件 -->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pagination.currentPage" :page-sizes="pageSizes" :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
    </div>
  </div>
</template>

<script>
import apis from '@/api'
export default {
  name: 'ProductOverviewCard',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => ({
        currentPage: 1,
        pageSize: 6,
        total: 0
      })
    },
    pageSizes: {
      type: Array,
      default: () => [6, 10, 20, 30]
    },
    height: {
      type: Number
    }
  },
  data() {
    return {
      imgUrl: `${this.GLOBAL_ENV.VUE_APP_BASE_DOMAIN}${apis.OSS_GET.url}`
    }
  },
  methods: {
    handleSizeChange(newSize) {
      this.$emit('size-change', newSize)
    },
    handleCurrentChange(newPage) {
      this.$emit('current-page-change', newPage)
    },
    editProduct(item) {
      this.$emit('edit-product', item)
    },
    deleteProduct(item) {
      this.$emit('delete-product', item)
    },
    formatDateTime(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp * 1000)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
  }
}
</script>

<style scoped>
.device-overview-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* 卡片容器布局 */
.list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 10px;
  overflow-y: auto;
  height: calc(100% - 63px);
  margin-bottom: 15px;
}

/* 每个卡片样式 */
.iterm {
  flex: 0 0 calc(33.333% - 14px);
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  height: 480px;
}

/* 卡片内部样式 */
.product-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  border: none;
}

.el-card__body,
.el-main {
  padding: 10px;
}

/* 图片容器核心样式 - 第一层居中 */
.product-img {
  position: relative;
  height: 300px;
  /* 外层flex居中：水平+垂直 */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px 6px 0 0;
  padding: 10px;
  box-sizing: border-box;
  background: #f9f9f9;
  /* 确保容器本身占满高度 */
  flex-shrink: 0;
}

/* el-image外层容器 - 第二层居中 */
.img-content {
  /* 强制占满父容器的可用空间 */
  width: 100%;
  height: 100%;
  max-height: 100% !important;
  /* 内部flex居中，覆盖el-image默认布局 */
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* 关键：穿透控制el-image所有内部层级居中 */
/* 1. 控制el-image组件根层 */
.product-img :deep(.el-image) {
  width: 100%;
  height: 100%;
  max-height: 100% !important;
  /* 第三层flex居中 */
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* 2. 控制el-image的图片容器层 */
.product-img :deep(.el-image__wrapper) {
  width: auto !important;
  height: auto !important;
  max-width: 100% !important;
  max-height: 100% !important;
  /* 第四层flex居中 */
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* 3. 控制最终的img标签 */
.product-img :deep(.el-image__inner) {
  width: auto !important;
  /* 宽度自适应 */
  height: auto !important;
  /* 高度自适应 */
  max-width: 100% !important;
  /* 宽度不超容器 */
  max-height: 100% !important;
  /* 高度不超容器 */
  object-fit: contain !important;
  /* 确保图片本身居中 */
  margin: 0 auto !important;
}

/* 修复预览遮罩层居中 */
.product-img :deep(.el-image__mask) {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-img-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  color: #999;
  font-size: 14px;
}

.hot-tag {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
  background-color: #FB2C36;
  border: #00000000;
  border-radius: 8px;
  color: #FFFFFF;
}

.product-info {
  padding: 12px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.product-name {
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 8px;
  color: #101828;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-type,
.product-spec {
  font-size: 16px;
  color: #6A7282;
  margin-bottom: 6px;
}

.product-desc {
  font-size: 16px;
  color: #4A5565;
  line-height: 24px;
  margin-bottom: 10px;
  flex: 1;
}

.product-footer {
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
  border-top: 1px solid #f0f0f0;
}

.product-date {
  font-size: 16px;
  color: #99A1AF;
}

/* 操作按钮样式优化 */
.product-actions {
  display: flex;
  gap: 15px;
}

.product-actions .el-button {
  padding: 5px 10px;
  font-size: 15px;
}

.delete-btn {
  color: #f56c6c;
}

/* 分页样式 */
.pagination {
  padding-right: 16px;
  text-align: right;
}

/* 响应式适配 */
@media (max-width: 1200px) {
  .iterm {
    flex: 0 0 calc(50% - 10px);
  }
}

@media (max-width: 768px) {
  .iterm {
    flex: 0 0 100%;
  }

  .product-img {
    height: 100px;
  }
}
</style>
